// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iQFO_","importantInfo":"styles_importantInfo__G51jy"};